import type {IFantasyData} from "data/stores/players/players.store";
import {get} from "lodash";

export const getPts = (stats: IFantasyData, field: keyof IFantasyData | null) => {
	if (!field) {
		return 0;
	}

	const value = get(stats, field, 0) as number;

	return {
		holes_win: value * 3,
		holes_halved: value * 1,
		holes_lost: value * -1,
		fairways_hit: value * 0.5,
		green_in_reg: value * 0.5,
		hole_in_one: value * 5,
		holes_3_row: value * 5,
		no_holes_lost: value * 5,
		unplayed_holes: value * 1,
		points: value * 1,
		tie_match: value * 2,
		win_match: value * 6,
		lost_match: value * 1,
		holeNo: value,
		teamStanding: value,
		matchStatus: value,
		result: value,
	}[field];
};
